import { createOpenQuestion, deleteOpenQuestions, fetchOpenQuestionOfAMfh, updateOpenQuestion } from '@/api/mfh/open-question.api';
import type { IOpenQuestion, IUpdateOpenQuestion } from '@condo/domain';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { type MaybeRef, unref } from 'vue';

export interface IOpenQuestionSearchParams {
    mfhId: number;
}

export const useOpenQuestion = ({ searchParams, queryEnabled }: { searchParams?: MaybeRef<IOpenQuestionSearchParams>; queryEnabled?: MaybeRef<boolean> }) => {
    const query = useQuery(['mfh', 'open-question', searchParams], async () => fetchOpenQuestionOfAMfh(unref(searchParams).mfhId), {
        initialData: [],
        enabled: queryEnabled,
    });

    const { mutateAsync: createOpenQuestionMutation } = useMutation(async (payload: IOpenQuestion) => createOpenQuestion(payload), {});

    const { mutateAsync: updateOpenQuestionMutation } = useMutation(
        async (payload: { openQuestionId: number; body: IUpdateOpenQuestion }) => updateOpenQuestion(payload.openQuestionId, payload.body),
        {},
    );

    const { mutateAsync: deleteOpenQuestionsMutation } = useMutation(async (openQuestionIds: number[]) => deleteOpenQuestions(openQuestionIds), {});

    return {
        ...query,
        createOpenQuestion: createOpenQuestionMutation,
        updateOpenQuestion: updateOpenQuestionMutation,
        deleteOpenQuestions: deleteOpenQuestionsMutation,
    };
};
